import React, { useState, useEffect } from 'react';
import { Flex, FlexItem, Image } from '@chatui/core';
import HeadeNavbar from '../components/headeNavbar'
import { getCategory } from '../services/ticket';
import { searchObj } from '../utils/util';
import { entity, isEntity } from '../utils/entity';

const WorkOrderList = props => {
  const [templateList, setTemplateList] = useState([]);

  useEffect(() => {
    const search = searchObj(props.location.search);
    if (search && search.game_id) {
      getCategory({ gameId: search.game_id })
        .then(res => {
          if (res.code === 0 && res.data.code === 0) {
            setTemplateList(res.data.data)
          }
        })
    } else {
      window.location.replace(`${window.location.origin}/closeWin`)
    }
  }, [props.location, props.history]);

  return (
    <HeadeNavbar title={"问题反馈"} myButton close={!entity.ai}>
      {templateList.map((item, index) => {
        return <Flex key={item.id} direction='column' style={{ padding: '8px 16px' }}>
          <FlexItem style={{ marginLeft: '0.75em', marginTop: '1em', paddingLeft: '12px', borderStyle: 'none none none solid', borderColor: "var(--brand-1)", borderWidth: '4px' }}>
            <span style={{ fontSize: '18px', lineHeight: '18px' }}>{item.name}</span>
          </FlexItem>
          <FlexItem style={{ marginLeft: '1em', marginRight: '1em' }}>
            <Flex direction='row' wrap='wrap' justifyContent='flex-start'>
              {item.tpl.map((_item, _index) => {
                return <FlexItem key={_item.id} flex='none' style={{
                  margin: '8px 4px',
                  width: '70px',
                }} >
                  <Flex
                    direction='column'
                    justifyContent='center'
                    alignItems='stretch'
                    onClick={() => { props.history.push({ pathname: '/workOrderSubmit', search: props.location.search, query: { tplId: _item.id } }) }}
                  >
                    <FlexItem alignSelf='auto' style={{
                      textAlign: 'center',
                      marginTop: '5px',
                      marginBottom: '10px',
                    }}>
                      <Image src={_item.icon} width="30" height="30" lazy alt={_item.title} />
                    </FlexItem>
                    <FlexItem alignSelf='auto' style={{ textAlign: 'center' }}>
                      <span style={{ fontSize: '12px' }}>{_item.title}</span>
                    </FlexItem>
                  </Flex>
                </FlexItem>
              })}
            </Flex>
          </FlexItem>
        </Flex>
      })
      }
      {isEntity("youzu") &&
        <Flex center direction='column' justifyContent='center' style={{ marginTop: '15px' }}>
          <FlexItem>
            <span>如以上支持仍无法解决您的问题，您可在QQ向游族企业号</span>
          </FlexItem>
          <FlexItem>
            <span><span style={{ color: "var(--brand-1)" }}>4006689919</span> 提问咨询</span>
          </FlexItem>
        </Flex>}
    </HeadeNavbar>
  );
};

export default WorkOrderList;
